import React, { Suspense } from 'react';

import { LoadingSpinner } from 'components/Common/Spinner';
import { Outlet } from 'react-router-dom';

const AppContent = () => {
  return (
    <section className="flex-1 md:mb-[158px] md:flex-none">
      <Suspense fallback={LoadingSpinner}>
        <Outlet />
      </Suspense>
    </section>
  );
};

export default React.memo(AppContent);
